import { Field } from '@progress/kendo-react-form';
import React from 'react'; 
import config from '../appconfig/config.json';
import appDetailsData from '../data/persondetailsdata.json';
import { CusFormLabel } from '../validation/Form-Components';
import CusFormTitle from './CusFormTitle';
import MyInfoPersonDetails from './MyInfoPersonDetails';
import PersonCPFHistory from './PersonCPFHistory';
import PersonIncomeCPF from './PersonIncomeCPF';
import PersonResiAddress from './PersonResiAddress';
import helper from '../factory/Helper';
import titles from '../data/titles.json';
import marStatusArray from '../data/maritalstatus.json';
import countries from '../data/countries.json';
import storage from '../factory/StorageFactory';

const PersonDtlsPreview = (props) => {

    const { personDetails, isFirstUser,cpfHistory,yrOfAssessment} = props;
 

    return(
        <div  style={{paddingBottom:'10px'}}>
            {Object.entries(personDetails).length !== 0 &&
                <div>

                <Field component={CusFormLabel} 
                    leftLabelId={'lblName'} leftLabelName={appDetailsData.label.n}
                    id={'Name'} name={personDetails.myInfo.Person_Name && personDetails.myInfo.Person_Name !== null? personDetails.myInfo.Person_Name:''} />

                    <MyInfoPersonDetails personDetails={personDetails} /> 

                    <Field component={CusFormLabel} 
                        leftLabelId={'lblTitle'} leftLabelName={appDetailsData.titleDDL.lblname} 
                        id={'title'} name={personDetails.myInfo.TitleCode !==null? helper.getLabelInArray(personDetails.myInfo.TitleCode,titles):''} />

                    <Field component={CusFormLabel} 
                        leftLabelId={'lblCnOfDom'} leftLabelName={appDetailsData.label.countryOfDom} 
                        id={'CnOfDom'} name={personDetails.myInfo.CountryOfResidenceCode !==null? helper.getLabelInArray(personDetails.myInfo.CountryOfResidenceCode,countries):''} />

                    <Field component={CusFormLabel} 
                        leftLabelId={'lblCnOfDom'} leftLabelName={appDetailsData.marStatusDDL.lblname} 
                        id={'CnOfDom'} name={personDetails.myInfo.MaritalStatusCode !==null? helper.getLabelInArray(personDetails.myInfo.MaritalStatusCode,marStatusArray):''} />
                    
                    <Field component={CusFormLabel} 
                        leftLabelId={'lblMobileNo'} leftLabelName={appDetailsData.label.mno} 
                        id={'MobileNo'} name={personDetails.myInfo.MobileNumber !== null? personDetails.myInfo.MobileNumber:''} />
    
                    <Field component={CusFormLabel} 
                        leftLabelId={'lblEmailAdd'} leftLabelName={appDetailsData.label.em} 
                        id={'EmailAdd'} name={personDetails.myInfo.Email_Address !== null? personDetails.myInfo.Email_Address:''} />

                    <Field component={CusFormTitle} id={config.route.PersonDetails} name={appDetailsData.formSubTitle.ST2} showEdit={false}   />
            
                    <PersonResiAddress applicantDetails={personDetails} />

                    {personDetails.showCPFAndNOA &&
                        <div>
                        <Field component={CusFormTitle} id={config.route.PersonDetails} name={appDetailsData.formSubTitle.ST3} showEdit={false}   />
            
                        <PersonIncomeCPF data={yrOfAssessment} />

                        <PersonCPFHistory minData={cpfHistory.minData} maxData={cpfHistory.maxData} />
                        </div>
                    }
                    {(storage.getIsFProdBTL() === 't') &&
                    <>
                    <Field component={CusFormTitle} id={config.route.PersonDetails} name={appDetailsData.formSubTitle.ST4} showEdit={false}   />
                    <Field component={CusFormLabel} 
                        leftLabelId={'lblMhLoanInstallment'} leftLabelName={appDetailsData.label.mhLoanInstallment} 
                        id={'MhLoanInstallment'} name={personDetails.myInfo.isJointContributerForMortgageLoan?personDetails.myInfo.isJointContributerForMortgageLoan:''} />
                    </>
                    }
            </div>}
            

        </div>
    )
}

export default PersonDtlsPreview;